module.exports = __webpack_public_path__ + "static/img/sys.f2e79d03.png";